import React, { useState } from 'react';
import { X } from 'lucide-react';
import { RYAN_MEDICAL_ICON_MAP, RYAN_MEDICAL_ICON_GROUPS, getRyanMedicalIconLabel } from '../constants/ryanMedicalIcons';
import './RyanSubdeckIconPicker.css';

interface RyanSubdeckIconPickerProps {
  value: string | null;
  onChange: (iconId: string | null) => void;
}

/**
 * Seletor de ícone do subdeck — abas por sistema do corpo, mesmo padrão do
 * DeckIconPicker.tsx (GRAIA), mas sobre o registro médico exclusivo do Ryan
 * (RYAN_MEDICAL_ICON_MAP/RYAN_MEDICAL_ICON_GROUPS).
 */
const RyanSubdeckIconPicker: React.FC<RyanSubdeckIconPickerProps> = ({ value, onChange }) => {
  const initialGroup = RYAN_MEDICAL_ICON_GROUPS.findIndex(g => g.icons.includes(value || ''));
  const [activeGroup, setActiveGroup] = useState(initialGroup >= 0 ? initialGroup : 0);

  const currentIcons = RYAN_MEDICAL_ICON_GROUPS[activeGroup]?.icons || [];

  return (
    <div className="rsip-root">
      <div className="rsip-tabs">
        {RYAN_MEDICAL_ICON_GROUPS.map((group, i) => (
          <button
            key={group.id}
            type="button"
            className={`rsip-tab${activeGroup === i ? ' rsip-tab--active' : ''}`}
            onClick={() => setActiveGroup(i)}
          >
            {group.label}
          </button>
        ))}
      </div>

      <div className="rsip-grid">
        {currentIcons.map(name => {
          const IconComp = RYAN_MEDICAL_ICON_MAP[name];
          if (!IconComp) return null;
          return (
            <button
              key={name}
              type="button"
              className={`rsip-icon-btn${value === name ? ' rsip-icon-btn--active' : ''}`}
              onClick={() => onChange(name)}
              title={getRyanMedicalIconLabel(name)}
            >
              <IconComp size={18} />
            </button>
          );
        })}
      </div>

      {value && (
        <button type="button" className="rsip-clear-btn" onClick={() => onChange(null)}>
          <X size={12} /> Remover ícone selecionado
        </button>
      )}
    </div>
  );
};

export default RyanSubdeckIconPicker;
